module.exports = __webpack_public_path__ + "static/media/5-min.e7b8610f.jpg";